// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2TJ9j","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__2KCxb"};